import listTemplate from 'emun.on-demand/admin/od-product-manager.list.htm'
import gridTemplate from 'emun.on-demand/admin/od-product-manager.grid.htm'
import headerTemplate from 'emun.on-demand/admin/od-product-manager.header.htm'
import actionsTemplate from 'emun.on-demand/admin/od-product-manager.actions.htm'
import multiViewTemplate from 'emun.on-demand/admin/od-product-manager.multi-view.htm'
import resolve from 'ioc/resolve'
import ProductManagerDependentController from 'emun.on-demand/admin/od-product-manager-dependent.controller'

let ProductManagerDependentComponent = {
    bindings: {
        product: '<?',
        type: '&'
    },
    require: {
        manager: '^odProductManager'
    },
    controller: ProductManagerDependentController,
    templateUrl($element, $attrs) {
        if($attrs.templateUrl) return $attrs.templateUrl;
        else if($attrs.type === 'multi-view') return multiViewTemplate;
        else if($attrs.type === 'list') return listTemplate;
        else if($attrs.type === 'grid') return gridTemplate;
        else if($attrs.type === 'header') return headerTemplate;
        else return actionsTemplate;
    }
}

export default ProductManagerDependentComponent;